module.exports = __webpack_public_path__ + "img/bannerDoc.73212902.webp";